import { FAQ } from "@kohler-dsm-library/kohler-modules"
import React from "react"
import styles from "@/components/Remedy/components/FAQSection/FAQSection.module.scss"
import { handleFAQAnalytics } from "@/components/Remedy/components/analytics"

export const FAQSection = () => {
  return (
    <section id="pxp-faq-section" className={styles["pxp-faq-section"]}>
      <style
        dangerouslySetInnerHTML={{
          __html: `
        #pxp-faq-section .dsm-typography-h2-h5 {
          color: var(--content-primary) !important;
        }

        #pxp-faq-section .dsm-typography-div-paragraph-medium {
          color: var(--content-primary) !important;
        }

        #pxp-faq-section p {
          color: var(--content-primary) !important;
        }
        
        
        #pxp-faq-section  .dsm-typography-h2-h2 {
          font-size: 45px !important;
        }
        @media (max-width: 640px) {
          #pxp-faq-section  .dsm-typography-h2-h2 {
            font-size: 28px !important;
          }
        }

        #pxp-faq-section  .dsm-typography-h2-h5 {
          font-size: 26px !important;
        }
        @media (max-width: 640px) {
          #pxp-faq-section  .dsm-typography-h2-h5 {
            font-size: 20px !important;
          }
        }

        #pxp-faq-section .dsm-typography-div-paragraph-medium {
          color: var(--dsm-color-gray-300) !important;
        }
        `,
        }}
      />
      <FAQ
        component="section"
        mod="charcoal"
        showHeader={false}
        heading={{ text: "Ice Bath FAQs" }}
        accordions={[
          {
            id: "1",
            title: {
              text: "How do I choose and order the right Ice Bath?",
              component: "span",
            },
            toggleCallback: (isOpen, title) => {
              handleFAQAnalytics(title?.text, isOpen)
            },
            children:
              "Call 866-766-4788 to speak with a specialist about product and ordering questions. We’ll help you find the right fit for your space and routine.",
          },
          {
            title: {
              text: "How long should a session last in the Ice Bath?",
              component: "span",
            },
            toggleCallback: (isOpen, title) => {
              handleFAQAnalytics(title?.text, isOpen)
            },
            children:
              "It is recommended to begin slowly until building a tolerance. Each person is different and should listen to their body depending on their tolerance and recovery needs. The built-in timer and guided breath light help monitor sessions.",
          },
          {
            title: {
              text: "How does the Ice Bath improve overall health and wellness?",
            },
            toggleCallback: (isOpen, title) => {
              handleFAQAnalytics(title?.text, isOpen)
            },
            children: (
              <>
                <p>
                  Cold therapy offers both mental and physical benefits, such
                  as:{" "}
                </p>
                <ul>
                  <li>Reducing inflammation</li>
                  <li>Enhancing muscle recovery</li>
                  <li>Reducing soreness</li>
                  <li>Boosting mood</li>
                  <li>Reducing stress</li>
                  <li>Increasing mental resilience</li>
                </ul>
              </>
            ),
          },
          {
            title: {
              text: "Is the Ice Bath suitable for recovery after everyday workouts?",
            },
            toggleCallback: (isOpen, title) => {
              handleFAQAnalytics(title?.text, isOpen)
            },
            children:
              "Yes, the Ice Bath is beneficial in reducing muscle soreness and inflammation post exercise. It also helps reduce recovery time.",
          },
          {
            title: { text: "How is the Ice Bath cleaned and maintained?" },
            toggleCallback: (isOpen, title) => {
              handleFAQAnalytics(title?.text, isOpen)
            },
            children:
              "The Ice Bath offers optimized cleaning features. 24/7 water filtration and UV light technology keep the bath ready for the next use, and with easy filter replacements, maintenance is more convenient. Water should be drained every 1-2 months for normal residential use, or as needed. Filters should be replaced every month for normal residential use, or as needed. Extra filters are available on Kohler.com.",
          },
          {
            title: { text: "Can the Ice Bath be used outdoors?" },
            toggleCallback: (isOpen, title) => {
              handleFAQAnalytics(title?.text, isOpen)
            },
            children:
              "Yes, the Ice Bath is designed for both indoor and outdoor use, constructed of durable materials tested to withstand the outdoor environment. Simply connect the bath's supply line to an outdoor garden hose and let it fill. Included in your purchase is an insulated spa cover to help keep the water clean in outdoor environments. For outdoor installations in extreme conditions or when additional protection is desired, a durable dust and rain cover is available at Kohler.com",
          },
          {
            title: {
              text: "Does the Ice Bath require special plumbing or electrical setup?",
            },
            toggleCallback: (isOpen, title) => {
              handleFAQAnalytics(title?.text, isOpen)
            },
            children:
              "The Ice Bath integrates easily with standard home plumbing and electrical systems for ease of filling and draining. For indoor installation and connection to in-home water supply, a ASSE 1001 vacuum breaker is required. Please consult local plumbing codes. The Ice Bath requires a GFCI-protected dedicated 110V outlet within 12’ of the desired placement of the ventilated end panel of the Ice Bath. An extension cord is not recommended.",
          },
          {
            title: { text: "How does the Kohler app enhance the experience?" },
            toggleCallback: (isOpen, title) => {
              handleFAQAnalytics(title?.text, isOpen)
            },
            children:
              "The Kohler app provides educational content, tracks progress, and offers guided meditation with Dr. Jonathan Leary to ensure a seamless and personalized wellness experience. The Kohler app can help set cold plunging schedules, monitor how you feel during and after your plunge, and send reminders so you stay on track with your cold plunging goals.",
          },
          {
            title: {
              text: "What makes this Ice Bath different from others on the market?",
            },
            toggleCallback: (isOpen, title) => {
              handleFAQAnalytics(title?.text, isOpen)
            },
            children: (
              <>
                <p>
                  The Ice Bath comes with UL Certification, a globally
                  recognized mark of safety and performance standards.
                </p>
                <p>
                  The Ice Bath integrates easily with standard home plumbing and
                  electrical systems. Once placed on a level floor, it can be
                  filled and the water chiller set to the desired temperature.
                  There is also the option to integrate it into the home
                  plumbing line for easy filling and draining.
                </p>
                <p>
                  The Ice Bath offers optimized cleaning features. 24/7 water
                  filtration and UV light technology keep the bath ready for the
                  next use, and with easy filter replacements, maintenance is
                  more convenient.
                </p>
                <p>
                  The Ice Bath features a sleek silhouette, dramatic lighting,
                  and premium materials to make a bold statement in any space.
                </p>
                <p>
                  Every detail of the Ice Bath focuses on helping develop mental
                  and physical resilience to become the best version of oneself,
                  like the Breath Light and Digital Timer.
                </p>
                <p>
                  The ergonomic design ensures ideal body positioning,
                  emphasizing stability and alignment to enhance the experience.
                </p>
              </>
            ),
          },
          {
            title: {
              text: "What is the temperature threshold of the bath?",
            },
            toggleCallback: (isOpen, title) => {
              handleFAQAnalytics(title?.text, isOpen)
            },
            children:
              "The Ice Bath can cool down to 39°F and heat up to 104°F. If placed outdoors and in extreme environments (ex. temperatures above 105°F or below 10°F), these thresholds may be more challenging to reach.",
          },
          {
            title: {
              text: "Are there any space requirements before installing the ice bath?",
            },
            toggleCallback: (isOpen, title) => {
              handleFAQAnalytics(title?.text, isOpen)
            },
            children: (
              <>
                <p>
                  The space should be a level floor that can withstand
                  condensation from the system and repeated exposure to water as
                  users enter and exit the bath.
                </p>
                <p>
                  The space should have ample room for air flow and clearance,
                  as the Ice Bath requires 3-4’ of ventilation on each side
                  except the headrest side, requiring 2-3’ of ventilation. This
                  space is required for both ventilation and accessibility.
                </p>
                <p>
                  The space should have a GFCI-protected dedicated 110V outlet
                  within 12’ of the desired placement of the ventilated end
                  panel of the Ice Bath. An extension cord is not recommended.
                </p>
                <p>
                  The space should be able to accommodate the weight of the Ice
                  Bath, 550 pounds dry. After install, the Ice Bath will be
                  challenging to relocate and should not be moved without
                  assistance.
                </p>
              </>
            ),
          },
          {
            title: {
              text: "What can I expect after my purchase?",
            },
            toggleCallback: (isOpen, title) => {
              handleFAQAnalytics(title?.text, isOpen)
            },
            children: (
              <>
                <p>
                  Once you complete your purchase, here’s what will be
                  delivered: The Ice Bath, cushioned headrest, insulated spa
                  cover, integrated filling hose, and one 30-micron filter. Your
                  purchase includes complimentary white glove delivery service.
                </p>
                <p>
                  Complimentary white glove service is only available for first
                  floor delivery locations. If the desired placement is in a
                  basement, on a second floor or higher, or requires elevator
                  access, a custom delivery quote will be provided at the
                  homeowner’s expense.
                </p>
                <p>
                  You’ll receive an email from our third-party logistics partner
                  to schedule a date for delivery and provide tracking details.
                </p>
                <p>On delivery day, our white glove team will:</p>
                <ul>
                  <li>
                    Bring the Ice Bath into your home and install in a
                    first-floor location{" "}
                  </li>
                  <li>Professionally place and level the unit </li>
                  <li>Remove all packaging and debris </li>
                </ul>
              </>
            ),
          },
          {
            title: {
              text: "Is the Ice Bath for Residential or Commercial use?",
            },
            toggleCallback: (isOpen, title) => {
              handleFAQAnalytics(title?.text, isOpen)
            },
            children:
              "The Ice Bath meets the codes and standards for residential use. If the product is installed in a commercial application, the 2-year warranty is void.",
          },
        ]}
      />
    </section>
  )
}
